import { HttpLink } from "apollo-link-http"
import { onError } from "apollo-link-error"

export const errorLink = onError(({ graphQLErrors, networkError }) => {
  /*
  onError receives a callback in the event a GraphQL or network error occurs.
  This example is a bit contrived, but in the real world, you could connect
  a logging service to the errorLink or perform a specific action in response
  to an error.
  */
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
          locations
        )}, Path: ${JSON.stringify(path)}`
      )
    )
  if (networkError) console.log(`[Network error]: ${networkError}`)
})

export const queryOrMutationLink = (config = {}) => {
  return new HttpLink({
    ...config,
    credentials: "same-origin",
  })
}
